import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { apiService } from '../../../../../../service/api.service'
import { ResponseAutoevaluacionModel, AutoevaluacionModel } from '../../../../../../model/Etapas.model'
import { MatDialog } from '@angular/material/dialog';
import { ModalAutoevaluacionMediosVerificacionComponent } from '../../../dialogs/modal-autoevaluacion-medios-verificacion/modal-autoevaluacion-medios-verificacion.component'
import { ModalConfirmarEliminacionComponent } from '../../../dialogs/modal-confirmar-eliminacion/modal-confirmar-eliminacion.component'
import { ModalConfirmarComponent } from '../../../dialogs/modal-confirmar/modal-confirmar.component'
import { ModalResumenMediosVerificacionComponent } from '../../../dialogs/modal-resumen-medios-verificacion/modal-resumen-medios-verificacion.component';
import { NgxSpinnerService } from "ngx-spinner";
import { MatTabChangeEvent } from '@angular/material/tabs';
import { JardinComponent } from 'src/app/components/jardin/jardin.component';
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import { StorageService } from 'src/app/service/storage.service';
@Component({
  selector: 'app-autoevaluacion',
  templateUrl: './autoevaluacion.component.html',
  styleUrls: ['./autoevaluacion.component.css']
})
export class AutoevaluacionComponent implements OnInit {
  @Input() simulacion: boolean;
  @ViewChild('divSpinnerAutoevaluacion') divSpinnerAutoevaluacion:ElementRef;
  autoEvaluacion = new Array<AutoevaluacionModel>();
  cargando = true;
  textoRetroAlimentacion = ['Sin Desarrollo','Mínimo', 'Débil', 'Incipiente','Satisfactorio','Avanzado'];
  finalizarAutoEvaluacion = true;
  ultimaPreguntaSeleccionada = 0;
  numTabSelected : number;
  dataJardin = new JardinModel();
  autoevaluacionFinish = false;
  constructor(
    @Inject(JardinComponent) private parent: JardinComponent,
    private api: apiService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.numTabSelected = 0;
    this.obtenerAutoevaluacion();
    //this.dataJardin = this.api.dataJardin;
    this.obtenerDataJardin();
    if (this.dataJardin.etapaJardin>2) {
      this.autoevaluacionFinish = true;
    }
  }

  obtenerDataJardin(){
    this.api.API_POST_obtenerJardin(this.storageService.getCurrentUser().idUsuario).subscribe((response:ResponseJardinModel) => {
      this.api.dataJardin = response.payload;
      this.dataJardin = response.payload;
    },
    (err) => { 
      console.log(err)
    })
  }

  obtenerAutoevaluacion(){
  
    this.api.API_POST_obtenerAutoevaluacion().subscribe((response: ResponseAutoevaluacionModel) => {
      this.autoEvaluacion = response.payload;
      this.validarEstadosAutoevaluacion();
    },
    (err) => {
      console.log(err)
    })     
  }

  validarEstadosAutoevaluacion(){
    //FOR AREA (ESTADO)
    let contadorAreas = 0;
    this.autoEvaluacion.forEach((area)=>{

      //FOR ACORDEONES (ESTADO)
      let contadorDimensionesFinalizadas = 0;
      let contadorDimensionesEnCurso = 0;
      area.dimensiones.forEach((dimension)=>{

        //FOR PREGUNTAS
        let contadorPreguntas = 0;
        let medioVinculado = true;
        dimension.elementos.forEach((pregunta)=>{

          //FOR Alternativas
          for (let iRetro = 0; iRetro < pregunta.retroAlimentacion.length; iRetro++) {
            if ( pregunta.retroAlimentacion[iRetro].seleccionada ){
              pregunta.finalizado = true;
              break;
            }             
          }
          if(pregunta.finalizado){
            contadorPreguntas++;
          } 

          if( !pregunta.retroAlimentacion[0].seleccionada && pregunta.vinculados.length === 0){
            medioVinculado=false;
          }

        });
        dimension.finalizado = (contadorPreguntas == 0 && !medioVinculado) ? 0 : (contadorPreguntas == dimension.elementos.length  && medioVinculado) ? 2 : 1;

        if(area.orden === 6){
          dimension.finalizado = 2;
        }

        if(dimension.finalizado == 2){
          contadorDimensionesFinalizadas++;
        }else if(dimension.finalizado == 1){
          contadorDimensionesEnCurso++;
        }

      });
      area.finalizado = (contadorDimensionesFinalizadas == area.dimensiones.length) ? 2 : (contadorDimensionesEnCurso > 0 || contadorDimensionesFinalizadas > 0) ? 1 : 0;
      if(area.orden === 6){
        area.finalizado = 2;
      }
      if(area.finalizado == 2){
        contadorAreas++;
      }

    });

    this.finalizarAutoEvaluacion = (contadorAreas == this.autoEvaluacion.length) ? false : true;

    this.cargando = false; 
    this.divSpinnerAutoevaluacion.nativeElement.style.display='none';

  }

  alternativaSeleccionada(area,dimension,elemento, posicion){ 
    if (!this.autoevaluacionFinish) {
      this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].retroAlimentacion.forEach((element)=>{
        element.seleccionada = false;
      });
      this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].retroAlimentacion[posicion].seleccionada = true;
      this.ultimaPreguntaSeleccionada = this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].retroAlimentacion[posicion].idRetroAlimentacion
      if(this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].retroAlimentacion[0].seleccionada === true){
        this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].vinculados = [];
      }
      this.enviarAlternativa();   
    }
  }

  guardar(){
    if(this.ultimaPreguntaSeleccionada != 0){
      this.enviarAlternativa();
    }
  }

  enviarAlternativa(){
    this.spinner.show();
    this.api.API_POST_guardarRespuestaAutoevaluacion(this.ultimaPreguntaSeleccionada).subscribe((response) => {    
      this.validarEstadosAutoevaluacion();
      this.spinner.hide();
    },
    (err) => {
      this.spinner.hide();
      console.log(err)
      
    }) 
  }

  agregarMedioVerificacion(area,dimension,elemento){

    let idElementoGestion = this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].idElementoGestion
 
    const dialogRef = this.dialog.open(ModalAutoevaluacionMediosVerificacionComponent ,{
      disableClose: true ,
      data: {idElementoGestion: idElementoGestion,
             vinculados: this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].vinculados},
      width: '70%',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].vinculados = result;
        this.validarEstadosAutoevaluacion();
      }
    });
  }


  eliminarMedio(id, area, dimension, elemento, vinculado){

    const dialogRef = this.dialog.open(ModalConfirmarEliminacionComponent, {
      disableClose: true ,
      data: {idMedioVerificacion: id, tipo: 'autoevaluacion'}
    }); 

    dialogRef.afterClosed().subscribe(result => {    
      if(result=='refresh'){
       this.autoEvaluacion[area].dimensiones[dimension].elementos[elemento].vinculados.splice(vinculado,1)
       this.validarEstadosAutoevaluacion();

      }
    });
    
  }

  descargarMedio(id){
    console.log(id)
    this.api.API_POST_descargarMediosVerificacion(id).subscribe((response) => {
      var save = document.createElement('a');   
      save.href = "data:"+response.payload.mime+";base64,"+response.payload.base
      save.target = '_blank';
      save.download = response.payload.nombre || 'archivo.dat';
      var clicEvent = new MouseEvent('click', {
          'view': window,
              'bubbles': true,
              'cancelable': true
      });
      save.dispatchEvent(clicEvent);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    },
    (err) => {
      console.log(err)
    })
  }

  
  verResumen(){

    const dialogRef = this.dialog.open(ModalResumenMediosVerificacionComponent, {
      disableClose: true ,
      data: this.autoEvaluacion,
      width: '65%',
    }); 

    dialogRef.afterClosed().subscribe(result => {
  
    }); 
    
  }

  finalizar(){

    const dialogRef = this.dialog.open(ModalConfirmarComponent, {
      disableClose: true ,
      width: '50%',
    }); 

    dialogRef.afterClosed().subscribe(result => {
      this.parent.menuVisible("autoevaluacion-inicio-view");

      location.reload();      
    }); 
    
  }

  irA(){
    this.parent.menuVisible("autoevaluacion-inicio-view");
  }


  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.numTabSelected = tabChangeEvent.index;
  }
}
